import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { updateDefault } from '@euroland/format-number'
import App from "./App";
import i18n from "@euroland/libs/locale/i18n";

import "./styles/index.scss";
import { store } from "./store";

import { getLanguage } from "./utils";
import { updateDefaultDateTime } from "@euroland/libs/utils/formatDate";

import { getCompanySettings } from "./services";
import { setSettings } from "./store/slice/settings";
import { waitForDocumentReady, isFunction, stringifyError } from "./utils/document-ready";
import { loadConfiguredCustomStylesheet, loadVariableStylesByTemplate, transitionDecimalDigitsToFormatNumber } from "./utils";
import { FORMAT_NUMBER, POSITIVE_NUMBER_FORMAT,  } from "./constant/common";

const initApp = setting => {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </React.StrictMode>
  );

  return setting;
};

const publicCompanySettings = settings => {
  const settingsData = settings?.data?.settings;
  const { thousandsSeparator, negativeNumberFormat, decimalSeparator, decimalDigits, positiveNumberFormat } =  settingsData?.format || {};
  let formatNumber = transitionDecimalDigitsToFormatNumber(decimalDigits);
  let useLatinNumbers = window.appSettings.isRtl ? settingsData.useLatinNumbers : true;

  updateDefault({
    groupingSeparator: thousandsSeparator,
    decimalSeparator,
    format: formatNumber || FORMAT_NUMBER,
    nagativeFormatPattern: negativeNumberFormat,
    positiveFormatPattern: positiveNumberFormat || POSITIVE_NUMBER_FORMAT,
    useLatinNumbers: useLatinNumbers
  });
  const instruments = settings?.data?.settings?.instruments;
  let instrument = instruments?.find(ins => !!ins?.default);
  let timezone = (instrument || instruments[0])?.customTimezone || settingsData?.timeZone;

  updateDefaultDateTime({
    timezone,
    settingFormat: {
      ...settingsData?.format,
    },
    useLatinNumbers: useLatinNumbers

  })
  store.dispatch(setSettings(settings?.data?.settings));
  return settings;
};
const loadTranslations = settings => {
  const locale = getLanguage();
  const listCustomPhrases = settings?.data?.customPhrases;
  let translations = window.appSettings.translations ;
  if (listCustomPhrases?.length) {
    const customPhrases = listCustomPhrases.reduce((s, c) => ({ ...s, [c.key]: c.value }), {});translations = { ...customPhrases, ...translations };
  }
  i18n.load(locale, translations);
  return settings;
};

const loadCustomPharses = settings => {
  if (settings?.data?.customPhrases?.length) {
    i18n.setCustomPhrases(settings?.data?.customPhrases?.reduce((s, c) => ({ ...s, [c.key]: c.value }), {}));
  }
  return settings;
};

function integrate(settings) {
  Promise.all([/*isIFrame(),*/ /*integrationScriptPromise,*/ waitForDocumentReady()])
    .then(() => {
      // Refer to https://gitlab.euroland.com/tools/flipit/integration/-/blob/master/doc/integration-api.md for more detail of implementing integration.
      if (window.euroland && isFunction(window.euroland.integrate)) {
        window.euroland.integrate({
          toolName: window.appSettings.integrationAppName,
          companyCode: window.appSettings.companyCode,
          version: window.appSettings.companyCodeVersion,
          lang: window.appSettings.language,
          allowedParentDomains: settings?.data?.settings?.allowedParentDomains || '*'
        });
      } else {
        throw new Error('Unknown Integration API "window.euroland.integrate".');
      }
    })
    .catch(err => {
      // TODO: just log on dev environment.
      console.warn(`Something wrong occurred with integration script. Stack Traces: ${stringifyError(err)}`);
    });
}

function integrateGoogleAnalytics(settings){
  const googleAnalyticsEnabled = settings?.data?.settings?.googleAnalyticsEnabled ?? false;
  const googleAnalyticUrl = window.appSettings.googleAnalyticUrl ?? null;
    if(googleAnalyticsEnabled && !!googleAnalyticUrl){
      let src = document.createElement("script");
      src.src = googleAnalyticUrl;
      (document.head || document.documentElement).appendChild(src);
  }
  return settings;
}

getCompanySettings()
  .then(integrateGoogleAnalytics)
  .then(loadConfiguredCustomStylesheet)
  .then(loadVariableStylesByTemplate)
  .then(publicCompanySettings)
  .then(loadTranslations)
  .then(loadCustomPharses)
  .then(initApp)
  .then(integrate);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
//registerServiceWorker();
